import React from "react"
import idHelper from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import tracking from "@irati-tracking/wallet/rewardPointsWallet"
import authentication from "@irati/auth"
import WalletLink from "../../shared/WalletLink"

interface Props extends InjectIntl {
  id?: string
}

const AdminRewardWallet: React.FC<Props> = (props) => {
  if (!authentication.apps("wallet.flexiRewards.canRewardEmployees")) {
    return null
  }

  const canTopUp = authentication.apps("wallet.flexiRewards.canTopUpRewardPoints")

  return (
    <WalletLink
      id={idHelper("link-reward-wallet", props)}
      onClick={() => tracking.clickRewardPointsWallet(canTopUp ? "Admin" : "Manager")}
      text={props.formatMessage({id: "platform.wallet.menu.flexiRewards.title"})}
      to="/flexi-reward" />
  )
}

export default injectIntl(AdminRewardWallet)
